import { useState, useMemo } from 'react';

const ITEMS_PER_PAGE = 20;

export function usePagination<T>(data: T[], searchFields: (item: T) => (string | undefined)[], filterPredicate?: (item: T) => boolean) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const scoped = filterPredicate ? data.filter(filterPredicate) : data;
    if (!search.trim()) return scoped;
    const s = search.toLowerCase();
    return scoped.filter((item) =>
      searchFields(item).some((field) => (field || '').toLowerCase().includes(s))
    );
  }, [data, search, searchFields, filterPredicate]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
  const safePage = Math.min(page, totalPages);
  const startIndex = (safePage - 1) * ITEMS_PER_PAGE;
  const paginatedData = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleSearch = (value: string) => {
    setSearch(value);
    setPage(1);
  };

  return {
    search,
    setSearch: handleSearch,
    page: safePage,
    setPage,
    totalPages,
    filteredData: filtered,
    paginatedData,
    totalFiltered: filtered.length,
    startIndex,
    endIndex: Math.min(startIndex + ITEMS_PER_PAGE, filtered.length),
  };
}
